
import FinAgentNewsSection from '@/components/finagent/FinAgentNewsSection';

export default {
    name: "FinAgentNewsList",

    components: {
        FinAgentNewsSection,
    },

    props: {
        configurations: {
            type: Array,
            default: () => []
        },
    },
}
